export const postTemplates = [
  {
    id: 1,
    name: "Product Launch",
    title: "🚀 Exciting Product Launch Alert!",
    hashtags: "#ProductLaunch, #Innovation, #NewProduct, #TechUpdate, #LaunchDay",
    content: `🎉 We're thrilled to announce the launch of our latest product! 

After months of hard work and dedication, we're finally ready to share this game-changing solution with you.

✨ Key Features:
• Revolutionary design
• Enhanced user experience
• Cutting-edge technology
• Seamless integration

Ready to experience the future? Get yours today!

#ProductLaunch #Innovation #NewProduct`
  },
  {
    id: 2,
    name: "Team Achievement",
    title: "🏆 Celebrating Our Amazing Team Success!",
    hashtags: "#TeamWork, #Success, #Achievement, #Proud, #TeamSpirit",
    content: `👏 Huge congratulations to our incredible team! 

We've just achieved a major milestone that wouldn't have been possible without everyone's dedication and hard work.

🌟 This success represents:
• Months of collaborative effort
• Innovation at its finest
• Commitment to excellence
• The power of teamwork

Thank you to everyone who made this possible! Here's to many more achievements ahead! 🚀

#TeamWork #Success #Achievement`
  },
  {
    id: 3,
    name: "Customer Testimonial",
    title: "💬 What Our Customers Are Saying",
    hashtags: "#CustomerLove, #Testimonial, #HappyCustomers, #Feedback, #Success",
    content: `⭐ "This service has completely transformed our business operations. The results exceeded our expectations!" - Sarah M., CEO

We're incredibly grateful for feedback like this! Our customers' success is our success.

🙏 Thank you to all our amazing clients who trust us with their business needs. Your success stories inspire us to keep innovating and delivering excellence every day.

#CustomerLove #Testimonial #HappyCustomers`
  },
  {
    id: 4,
    name: "Industry News",
    title: "📰 Latest Industry Insights & Trends",
    hashtags: "#IndustryNews, #Trends, #Innovation, #BusinessInsights, #MarketUpdate",
    content: `📊 The industry landscape is evolving rapidly, and we're here to keep you informed!

🔍 Key trends we're watching:
• Digital transformation acceleration
• AI integration in daily operations
• Sustainable business practices
• Remote work optimization

Stay ahead of the curve with our expert insights and solutions. What trends are you most excited about?

#IndustryNews #Trends #Innovation`
  },
  {
    id: 5,
    name: "Event Promotion",
    title: "🎪 Don't Miss Our Upcoming Event!",
    hashtags: "#Event, #Registration, #Networking, #Learning, #Community",
    content: `📅 Save the Date! We're hosting an exclusive event you won't want to miss.

🎯 What to expect:
• Expert speakers and industry leaders
• Networking opportunities
• Interactive workshops
• Latest product demonstrations
• Complimentary refreshments

📍 Date: [Insert Date]
🕒 Time: [Insert Time]
📍 Location: [Insert Location]

Limited spots available! Register now to secure your place.

#Event #Registration #Networking`
  },
  {
    id: 6,
    name: "Motivational Monday",
    title: "💪 Monday Motivation: Start Strong!",
    hashtags: "#MondayMotivation, #Inspiration, #Success, #Goals, #Mindset",
    content: `🌟 "Success is not final, failure is not fatal: it is the courage to continue that counts." - Winston Churchill

Starting a new week with fresh energy and determination! 

💡 This week, let's focus on:
• Setting clear goals
• Taking consistent action
• Embracing challenges as opportunities
• Supporting our team members

What's your goal for this week? Share it in the comments! 👇

#MondayMotivation #Inspiration #Success`
  }
];